import { API_PATHS, interpolatePathParams, ROUTE_PARAMS } from '@futrli/shared-services';
import { LOADER_AREAS } from '@futrli/ui-components';
import { trackPromise } from 'react-promise-tracker';
import { PAYMENT_TYPES, PAYMENT_TYPES_URL_PARAMS } from '../constants';
import { QueryParams } from '../types';
import { makeRequest, makeRequestWithResponse } from './shared';

/**
 * Change an assumption payment type, uses forecast ID, payment type, assumption ID
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get forecasts from
 * @param {string} forecastId - Forecast id
 * @param {string} assumptionId - assumption id
 * @param {string} paymentType - type of assumption
 * @param {object} data - post request data
 * @param {QueryParams} queryParams
 * @throws error
 * @returns Promise<void>
 */
export const changePaymentType = async (
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  assumptionId: string,
  paymentType: PAYMENT_TYPES,
  data: unknown = {},
  queryParams: QueryParams = {}
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.ASSUMPTION_PAYMENT_TYPE, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ASSUMPTION_ID]: assumptionId,
    [ROUTE_PARAMS.PAYMENT_TYPE]: PAYMENT_TYPES_URL_PARAMS[paymentType]
  });

  await trackPromise(
    makeRequest({ data, params: queryParams, url: path, method: 'POST' }),
    LOADER_AREAS.predictArea
  );
};

/**
 * get an assumption payment type, uses forecast ID, payment type, assumption ID
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get forecasts from
 * @param {string} forecastId - Forecast id
 * @param {string} assumptionId - assumption id
 * @param {string} paymentType - type of assumption
 * @param {string} paymentTypeId - id of assumption
 * @param {object} data - post request data
 * @param {QueryParams} queryParams
 * @throws error
 * @returns Promise<void>
 */
export const fetchPaymentType = async <T>(
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  assumptionId: string,
  paymentType: PAYMENT_TYPES,
  paymentTypeId: string,
  data: unknown = {},
  queryParams: QueryParams = {}
): Promise<T> => {
  const path = interpolatePathParams(API_PATHS.ASSUMPTION_PAYMENT_TYPE_BY_ID, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.FORECAST_ID]: forecastId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ASSUMPTION_ID]: assumptionId,
    [ROUTE_PARAMS.PAYMENT_TYPE]: PAYMENT_TYPES_URL_PARAMS[paymentType],
    [ROUTE_PARAMS.PAYMENT_TYPE_ID]: paymentTypeId
  });

  return makeRequestWithResponse<T>({ data, params: queryParams, url: path, method: 'GET' });
};
